import { otmsHttp } from '@/utils/http/index.js'

/**
 * 获取订单列表U订单
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8504
 */
 export function getTransportList(data, params) {
  return otmsHttp.request({
      url: '/unify/order/v2/transport/page',
      method: 'post',
      data,
      params,
      noEnterprise:true
  })
}

/**
 * 获取客户产品(计费产品)
 * 
 */
 export function getInterface(data) {
  return otmsHttp.post({
    url: '/customer/product/list',
    method: 'post',
    data,
  })
}

/**
 * 非标准下单 获取合同
 */
 export function getContract(data) {
  return otmsHttp.post({
    url: '/bfs_pricing_rule/contract/cargo_owner/list',
    method: 'post',
    data,
  })
}

/**
 * 取消订单U订单
 * 
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/9658
 */
 export function cancelOrderUnify(data) {
  return otmsHttp.request({
      url: '/unify/order/v2/batch/cancel',
      method: 'post',
      data
  })
}

/**
 * 订单导出
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8802
 */
 export function orderExportUnify(data) {
  return otmsHttp.request({
      url: '/unify/order/v2/transport/customer/export',
      method: 'post',
      data
  });
}